import React, { useCallback, useRef, useState } from "react";

//MUI
import { Grid } from "@mui/material";

//Config
import { appConfig } from "../utility/config";

//Components
import BidCreationLayoutPanel from "./project-details/bid-creation-section/BidCreationLayoutPanel";
import BidShareSection from "./project-details/bid-share-section/BidShareSection";
import ApprovalStatusSection from "./project-details/approval-status-section/ApprovalStatusSection";
import BidDetailsLayoutSection from "./project-details/bid-details-section/BidDetailsLayoutSection";
import DocumentsSection from "./project-details/documents-section/DocumentsSection";
import CommentsSection from "./project-details/comments-section/CommentsSection";
//import BidCreationBtn from "./project-details/bid-creation-section/BidCreationBtn";
import BidListSection from "./project-list/bid-list-section/BidListSection";
import Loader from "./loader/Loader";

//Types
import { IFilterProjectModel } from "../models/ProjectResponseModel";

//Actions
//import { setUserId } from "../redux/actions/ProjectActions";

type Props = {
  isFilteredResponse: boolean;
  resetProjectSelectionFlags: () => void;
  filteredProjects: IFilterProjectModel[];
  isProjectsFetching: boolean;
  particularProjectSP: any;
  showProjectDetails: boolean;
  handleDrawerToggle?: () => void;
  isPanelOpen: boolean;
  bidType: AddEdit;
  dismissPanel: () => void;
  handleOpenBidPanel: (type: AddEdit) => void;
};

export type AddEdit = "add" | "edit";
export type Mode = "user" | "admin";

const BidDetails = ({
  isFilteredResponse,
  resetProjectSelectionFlags,
  filteredProjects,
  isProjectsFetching,
  particularProjectSP,
  showProjectDetails,
  handleDrawerToggle,
  isPanelOpen,
  bidType,
  dismissPanel,
  handleOpenBidPanel,
}: Props) => {
  const rightSectionRef = useRef<HTMLDivElement>(null); // To scroll page to the top on bid selection
  const [isSideMenuExpanded, setIsSideMenuExpanded] = useState(true);

  const handleSideMenuToggle = () => {
    setIsSideMenuExpanded((prevValue) => !prevValue);
  };

  //   To Scroll the page to the top on any bid selection
  const scrollToTopOnBidSelection = useCallback(() => {
    if (rightSectionRef.current) {
      rightSectionRef.current.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  }, []);

  return (
    <Grid
      container
      bgcolor="#EAEAEA"
      height={`calc(100vh - ${
        appConfig.headerHeight + appConfig.dashboardStackHeight
      }px) `}
    >
      <Grid
        item
        xs={0}
        md={4}
        p={1}
        height="100%"
        flex={1}
        sx={{
          overflowY: "auto",
          display: isSideMenuExpanded ? { xs: "none", md: "block" } : "none",
        }}
      >
        <BidListSection
          isFiltered={isFilteredResponse}
          resetFlags={resetProjectSelectionFlags}
          projects={filteredProjects}
          scrollToTopOnBidSelection={scrollToTopOnBidSelection}
          handleDrawerToggle={handleDrawerToggle}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={isSideMenuExpanded ? 8 : 12}
        height="100%"
        ref={rightSectionRef}
        sx={{ overflowY: "auto" }}
      >
        <BidCreationLayoutPanel
          isOpen={isPanelOpen}
          dismissPanel={dismissPanel}
          type={bidType}
          mode="user"
        />
        {showProjectDetails ? (
          <>
            {particularProjectSP && particularProjectSP.projectId !== 0 && (
              <>
                <BidShareSection
                  data={particularProjectSP}
                  handleOpenBidPanel={handleOpenBidPanel}
                />
                {!particularProjectSP.isBidDropped ? (
                  <ApprovalStatusSection
                    projectId={particularProjectSP.projectId}
                  />
                ) : null}
                <BidDetailsLayoutSection
                  data={particularProjectSP}
                  handleSideMenuToggle={handleSideMenuToggle}
                  isSideMenuExpanded={isSideMenuExpanded}
                />
                <Grid container spacing={{ xs: 1, sm: 0 }} sx={{ pb: 1 }}>
                  <Grid item xs={12} md={5}>
                    <DocumentsSection />
                  </Grid>
                  <Grid item xs={12} md={7}>
                    <CommentsSection />
                  </Grid>
                </Grid>
              </>
            )}
          </>
        ) : isProjectsFetching ? (
          <Loader />
        ) : (
          <div>No Projects Found!</div>
        )}
      </Grid>
    </Grid>
  );
};

export default BidDetails;
